import React from 'react';
import { PropTypes as PT } from 'prop-types';
import AutosizeTextarea from 'react-textarea-autosize';

class ExpandableInput extends React.PureComponent {
  render() {
    const { className, input, maxLength, onClick } = this.props;

    return (
      <AutosizeTextarea
        className={className || ''}
        value={input.value}
        maxLength={maxLength || null}
        onChange={input.onChange}
        onClick={onClick}
      />
    );
  }
}

ExpandableInput.propTypes = {
  className: PT.string,
  input: PT.object,
  maxLength: PT.number,
  onClick: PT.func
};

export default ExpandableInput;
